import React from 'react';
import { Sparkles, Loader2 } from 'lucide-react';
import { cn } from '@/shared/lib/utils';
import { SubscriptionData } from '../types';

interface ActiveSubscriptionBannerProps {
    subscription: SubscriptionData;
    creditBalance: number;
    isActive: boolean;
    isPending: boolean;
    isProcessing: boolean;
    onCancel: () => void;
}

export const ActiveSubscriptionBanner: React.FC<ActiveSubscriptionBannerProps> = ({
    subscription,
    creditBalance,
    isActive,
    isPending,
    isProcessing,
    onCancel
}) => {
    if (!subscription) return null;

    return (
        <div className="mb-16">
            <div className="rounded-2xl bg-card/50 shadow-xl shadow-primary/5 ring-1 ring-border p-6 md:p-8 flex flex-col md:flex-row justify-between items-center relative overflow-hidden backdrop-blur-sm border border-border">
                <div className="absolute -right-20 -top-20 w-64 h-64 blur-[80px] rounded-full"></div>
                <div className="z-10 w-full mb-6 md:mb-0">
                    <div className="flex items-center gap-3 mb-2">
                        <Sparkles className="h-6 w-6 text-primary" />
                        <h3 className="text-xl font-bold text-foreground">
                            {isPending ? "Pending Plan:" : "Active Plan:"} <span className="text-primary uppercase tracking-wide">{subscription.planName || subscription.plan}</span>
                        </h3>
                        <span className={cn(
                            "text-[10px] px-2 py-0.5 rounded-full font-bold uppercase",
                            subscription.status === 'active' ? "bg-green-500/10 text-green-500" : "bg-amber-500/10 text-amber-500"
                        )}>
                            {subscription.status}
                        </span>
                    </div>
                    <p className="text-sm text-muted-foreground max-w-xl">
                        Your account is active. You have <span className="text-foreground font-bold">{creditBalance}</span> credits remaining for this billing cycle.
                    </p>
                </div>
                <div className="z-10 flex flex-col sm:flex-row gap-4 items-center w-full md:w-auto justify-center">
                    <div className="flex flex-col items-center border-x border-border/50 items-center">
                        <span className="text-2xl font-black text-foreground ">{creditBalance}</span>
                        <span className="text-[10px] uppercase tracking-tighter text-muted-foreground font-bold text-center">Credits Available</span>
                    </div>

                </div>
            </div>
        </div>
    );
};
